module.exports = __webpack_public_path__ + "assets/img/3e.bc779ce4.png";